module.exports = __webpack_public_path__ + "img/champagne.c9e62a79.png";